export const GlobalSettingSymbol = Symbol('globalSetting');
